import functions from '../functions.js';
import { details } from './details';
import { DetailsCart } from './details-cart.js';
import Slider from "../components/Slider";

$(() => {
    detailsCombined.init();
});

const detailsCombined = {
    $details: null,
    $booking: null,
    $form: null,
    form: null,
    $cart: null,
    cart: [],
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        aDateFrom: null,
        aDateTo: null,
        objectGroupId: null,
        calcErrorMessages: null,
    },
    defaults: {
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: 1,
    },
    init() {
        this.$details = $('.page-type-details');
        this.$booking = $('#booking');
        this.params.objectGroupId = this.$booking.attr('data-objectgroupid');

        if( ! (this.$details[0] && this.params.objectGroupId === "1" && +this.$booking.attr('data-dynamicpackage') === 0)) {
            return;
        }

        if(! $('[data-isBookingCombined]').attr('data-isBookingCombined')) {
            return;
        }

        this.params.objectId = this.$booking.attr('data-objectid');
        this.params.referenceId = this.$booking.attr('data-referenceid');
        this.params.calcErrorMessages = this.$booking.attr('data-calcErrorMessages') ? JSON.parse(this.$booking.attr('data-calcErrorMessages')) : null;

        this.$form = $('.availability-form');

        this.getParams();
        if(! this.params.dates && this.params.dateFrom && this.params.dateTo) {
            //this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }

        if(this.params.guests) {
            $('[name=guests]').val(this.params.guests);
            $('.input-guests')[0]._inputGuests.elemChange($('.input-guests')[0]._inputGuests);
        }

        this.initDepartureCalendar();
        //this.setDefaultDeparture();
        //this.setActiveDeparture();
        
        this.prepareAvailabilityForm();

        if(this.params.guests) {
            $('[name=guests]').each((index, elem) => {
                $(elem).val(this.params.guests);

                let guests = this.params.guests.split(',');
                let i = 1;
                for (let index = 2; index < guests.length; index++) {
                    if(guests[index]) {
                        $('[name=child-age-'  + i + ']').val(guests[index]);
                    }
                    i++;
                }
            });
        }

        this.getCalculation();

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length ? new DetailsCart(this.params) : [];

        $('.departure').on('click', e => {
            $('.departure').removeClass('active');

            const $target = $(e.currentTarget);
            $target.addClass('active');

            if (this.params.dynamicPackage == 2) {
                this.params.aDateFrom = $target.attr('data-datefrom');
                this.params.aDateTo = $target.attr('data-dateto');
                this.params.dateFrom = $target.attr('data-departuredatefrom');
                this.params.dateTo = $target.attr('data-departuredateto');
            } else {
                this.params.dateFrom = this.params.aDateFrom = $target.attr('data-datefrom');
                this.params.dateTo = this.params.aDateTo = $target.attr('data-dateto');
            }

            $('[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']').addClass('active');
            //this.printDates();

            functions.setUrlData({
                'dateFrom': this.params.dateFrom, 
                'dateTo': this.params.dateTo, 
                'guests': this.params.guests, 
                'aDateFrom': this.params.aDateFrom, 
                'aDateTo': this.params.aDateTo, 
                'flightUnitId': this.params.flightUnitId,
                'placeFromId': this.params.placeFromId,
            }, true, true);
        });

        $('[name=guests]').on('change', e => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            //this.params.unitId = $target.attr('data-unitid');
            this.params.guests = $target.val();

            //functions.setUrlData({'dateFrom': this.params.dateFrom, 'dateTo': this.params.dateTo, 'guests': this.params.guests }, true, true);
            //this.getCalculation();
        });

        if (! this.params.dynamicPackage) {
            $('.departure-bus-ticket').addClass('d-none');
        } else {
            $('.departure-sopstveni').addClass('d-none');
        }

        $(window).on('hashchange', e => {
            this.getParams();

            ! this.params.dateFrom && this.setDeparture();
            this.setGuestsInstances();
            (! this.params.guests || ! this.params.dateFrom) && this.setUnitRates();

            this.setActiveDeparture();
            this.setDeparturePoints();
            this.showTransportSelect();

            this.params.dynamicPackage && this.showTransportTicket();

            this.printDates();
            this.getCalculation(this.params);
        });
    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            //this.splitCalendarDates(this.params.dates);
        }
    },
    initDepartureCalendar() {
        const $bookingCalendar = $('#booking-calendar-slider');

        if($bookingCalendar[0]) {
            const length = $bookingCalendar.find('.keen-slider__slide').length;
            const perView = 7;
            
            let slidesPerView = length < perView ? length : perView;

            if(length < perView) {
                //$('.booking-calendar-wrapper').addClass('col-lg-' + (slidesPerView + 3));
                //$('.booking-calendar-wrapper').addClass('mx-auto');
            }
    
            this.slider = new Slider($bookingCalendar, {
                // mode: 'snap',
                //centered: true,
                duration: 200,
                fade: false,
                loop: false,
                controls: false,
                initial: 0,
                arrows: functions.isMobile() || length > slidesPerView,
                slides: {
                    perView: slidesPerView,
                    spacing: 0,
                },
                breakpoints: {
                    '(min-width: 993px) and (max-width: 1360px)': {
                        controls: true,
                        arrows: length > 5,
                        //centered: true,
                        slides: {
                            perView: 5,
                        },
                    },
                    '(min-width: 577px) and (max-width: 992px)': {
                        controls: true,
                        arrows: length > 4,
                        //centered: true,
                        slides: {
                            perView: 4,
                        },
                    },
                    '(max-width: 576px)': {
                        controls: true,
                        arrows: length > 2,
                        //centered: true,
                        slides: {
                            perView: 2,
                        },
                    },
                },
                detailsChanged: (s) => {
                    $('.booking-calendar-wrapper').find('[data-dir="prev"]').toggleClass('invisible', s.track.details.rel == 0);
                }
            });
        }
    },
    setDefaultDeparture() {
        this.params.dateFrom = ! this.params.dateFrom ? $('[data-datefrom]').attr('data-datefrom') : this.params.dateFrom;
        this.params.dateTo = ! this.params.dateTo ? $('[data-datefrom=' + this.params.dateFrom + ']').attr('data-dateto') : this.params.dateTo;
        this.params.guests = $('[name=guests]').val(); 

        let $departureItem = $('[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']');

        if ( ! $departureItem.length) {
            $departureItem = $('[data-departuredatefrom=' + this.params.dateFrom + '][data-departuredateto=' + this.params.dateTo + ']');
        }
        
        /*if (! $departureItem.length) {
            let closestDateFrom, closestDateTo = null;

            $('.departure[data-datefrom]').each((i, elem) => {
                const $elem = $(elem);
                const dateFrom = $elem.attr('data-datefrom');
                const dateTo = $elem.attr('data-dateto');

                if (closestDateFrom) return;

                if (Date.parse(dateFrom) >= Date.parse(this.params.dateFrom)) {
                    closestDateFrom = dateFrom;
                    closestDateTo = dateTo;
                    $departureItem = $elem;
                }
            });

            if ( ! closestDateFrom) {
                $($('.departure[data-datefrom]').get().reverse()).each((i, elem) => { 
                    const $elem = $(elem);
                    const dateFrom = $elem.attr('data-datefrom');
                    const dateTo = $elem.attr('data-dateto');

                    if (closestDateFrom) return;

                    if (Date.parse(dateFrom) <= Date.parse(this.params.dateFrom)) {
                        closestDateFrom = dateFrom;
                        closestDateTo = dateTo;
                        $departureItem = $elem;
                    }
                });
            }

            this.params.dateFrom = closestDateFrom;
            this.params.dateTo = closestDateTo;
        }*/

        $departureItem.addClass('active');
        //functions.setUrlData({'dateFrom': this.params.dateFrom, 'dateTo': this.params.dateTo, 'guests': this.params.guests }, true, true);

        this.slider && this.slider.instance.slides.forEach((slide, index) => {
            const $slide = $(slide);

            if($slide.find('.departure.active').length) {
                let slideIndex = index;
                const perView = this.slider.instance.options.slides.perView;
                const slidesLength = this.slider.instance.slides.length;
                const lastIndex = slidesLength - 1;

                if (slideIndex + perView >= lastIndex) {
                    const indexDiff = slideIndex === lastIndex ? 1 : lastIndex - slideIndex;
                    this.slider.instance.moveToIdx(slideIndex - (perView - indexDiff));
                } else if (slideIndex > perView) {
                    this.slider.instance.moveToIdx(slideIndex);
                }
            }
        });

        this.printDates();
    },
    setDeparture() {
        if(this.params.dateFrom) {
            $('.departure').removeClass('active');
            //$('.departure-sm').removeClass('active');
            this.params.dateTo = ! this.params.dateTo ? $('[data-datefrom=' + this.params.dateFrom + ']').attr('data-dateto') : this.params.dateTo;

            $('[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']').addClass('active');

            //this.printDates();
        } else {
            this.setDefaultDeparture();
        }
    },
    setGuestsInstances() {
        const $departure = $('.departure[data-datefrom=' + this.params.dateFrom + ']');
        let maxPersonsUnits = $departure.attr('data-maxPersonsUnits') ? JSON.parse($departure.attr('data-maxPersonsUnits')) : null;
        
        if(maxPersonsUnits) {
            Object.entries(maxPersonsUnits).forEach(item => {
                const unitId = item[0];
                const quantity = item[1];
    
                $('.input-guests[data-unitid="' + unitId + '"]').each((i, elem) => {
                    const instance = elem._inputGuests; 
                    instance.max = quantity ? quantity : instance.max;
                    instance.checkUpdateBtns(instance, 'adults');
                });
            });
        }
    },
    setUnitRates() {
        if(this.params.dateFrom) {
            this.loader();

            setTimeout(() => {
                const $departure = $('.departure[data-datefrom=' + this.params.dateFrom + '][data-rates]');
                const rates = $departure.attr('data-rates') ? JSON.parse($departure.attr('data-rates')) : null;

                let excludedUnits = [];

                $('.unit').each((index, elem) => {
                    if (rates) {
                        const unitIds = Object.keys(rates);
                        const unitId = $(elem).attr('data-unitid');

                        ! unitIds.includes(unitId) && excludedUnits.push(unitId);
                    }

                });

                if(excludedUnits.length) {
                    excludedUnits.forEach(unitId => {
                        const $unit = $('.unit[data-unitid="' + unitId + '"]');
                        $unit.find('.price-wrapper').addClass('d-none');
                        $unit.find('.badge-discount').addClass('d-none');
                        $unit.find('.add-to-cart').addClass('d-none');
                        $unit.find('.btn-request').removeClass('d-none');
                    });
                }

                $('.unit').parent('div').attr('style', 'order: 10000');
                $('.unit').find('.price-from-label').removeClass('d-none');

                rates && Object.entries(rates).forEach(item => {
                    const unitId = item[0];
                    const rate = item[1];
    
                    const $unit = $('.unit[data-unitid="' + unitId + '"]');
    
                    $unit.find('.price-wrapper').removeClass('d-none');
                    $unit.find('.badge-discount').removeClass('d-none');
                    $unit.find('.add-to-cart').removeClass('d-none');
                    $unit.find('.btn-request').addClass('d-none');

                    let priceOld = rate.priceWithDiscount ? rate.price : false;
                    $unit.find('.price-old').text(rate.priceWithDiscount ? rate.price : '');
                    $unit.find('.price').text(rate.priceWithDiscount ? rate.priceWithDiscount : rate.price);
                    priceOld ? $unit.find('.price').addClass('text-danger') : $unit.find('.price').removeClass('text-danger');
                    //$unit.find('.price').toggleClass('text-danger', priceOld);
    
                    //$unit.find('.fm-discount').toggleClass('d-none', ! rate.discountTitle);
                    //$unit.find('.fm-discount-title').text(rate.discountTitle ? rate.discountTitle : '');
                    //$unit.find('.fm-discount-valid-until').toggleClass('d-none', ! rate.validUntil);
                    //$unit.find('.fm-discount-valid-until-date').text(rate.validUntil ? rate.validUntil : '');

                    let price = rate.priceWithDiscount ? rate.priceWithDiscount : rate.price;
                    price = +price.replace('€ ', '');

                    $unit.parent('div').attr('style', 'order: ' + price);

                    $unit.find('.price-from-label').removeClass('d-none');
                    $unit.find('.total-label').addClass('d-none');
                });
            }, 0); // 800
        } else {
            $('.unit').find('.add-to-cart').addClass('d-none');
            $('.unit').find('.unit-price').addClass('d-none');
            $('.unit').find('.btn-request').removeClass('d-none');
            //$('.details-cart').addClass('d-none');
        }
    },
    loader($target = null) {
        /*$('.units').addClass('fade');
        $target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 600);
        setTimeout(() => {
            $('.units').removeClass('fade');
        }, 800);*/
    },
    printDates() {
        $('.date-from').text(functions.formatDate(this.params.dateFrom));
        $('.date-to').text(functions.formatDate(this.params.dateTo));
    },
    getCalculation(params) {
        const cParams = params ? params : this.params;
        cParams.dynamicPackage = cParams.transportUnitId && cParams.placeFromId ? '2' : cParams.dynamicPackage;
        const calculation = details.getCalculation(cParams);

        if(calculation) {
            details.unitsSpinner();
            calculation
                .done(response => {
                    this.calculationDone(response, cParams);
                }).fail(error => {
                console.log(error);
            });
        } else {

            this.setUnitRates();

            //$('.block-no-dates').removeClass('d-none');
            //$('.block-discount').removeClass('d-none');
            //$('.block-loading').addClass('d-none');
        }

        //$('.block-totals-per-service').addClass('d-none');
        //$('.block-booking').addClass('d-none');
        //$('.block-error-msg').addClass('d-none');
    },
    calculationDone(response, params) {
        if(response.status) {
            const data = response.data || [];

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = $('.unit[data-unitid=' + unitId + ']');
                const $addToCart = $unit.find('.add-to-cart');
                const isBookable = details.isBookable(unitData);
                
                if (isBookable) {
                    const unitCalc = unitData.calc;
                    const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                    const calcItems = unitCalc.items;

                    let priceOld = 0.00;
                    let discountTitle = null;

                    calcItems.forEach(item => {
                        // popust za djecu ne ulazi u prikaz discount cijene
                        if (item.itemDefinitionId == 109) return;

                        if ((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                            priceOld += item.itemTotal;
                        }
                        if (item.itemType == 'discount') {
                            discountTitle = item.itemTitle;
                            if (item.data && item.data.text) {
                                discountTitle = item.data.text;
                            }
                        }
                    });

                    let hasDiscount = priceOld && priceOld != unitCalc.total ? priceOld : null;

                    const totalOld = unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',');

                    $unit.find('.price').html(total);

                    if (hasDiscount) {
                        priceOld && $unit.find('.price-old').html(totalOld);
                        discountTitle && $unit.find('.badge-discount').html(discountTitle);
                        discountTitle && $unit.find('.badge-discount').removeClass('d-none');
                    } else {
                        $unit.find('.price-old').html('');
                        $unit.find('.badge-discount').addClass('d-none');
                    }

                    $unit.parent('div').prop('style', 'order: ' + Math.round(unitCalc.total) + ';');

                    $addToCart.attr('data-unitcarttotal', unitCalc.total);
                    $addToCart.attr('data-unitcarttotalold', priceOld);
                    $addToCart.attr('data-currencysymbol', unitCalc.currencySymbol);

                    $addToCart.attr('data-datefrom', detailsCombined.params.dateFrom);
                    $addToCart.attr('data-dateto', detailsCombined.params.dateTo);
                    $addToCart.attr('data-guests', detailsCombined.params.guests);

                    $addToCart.attr('data-adatefrom', detailsCombined.params.aDateFrom);
                    $addToCart.attr('data-adateto', detailsCombined.params.aDateTo);
                    $addToCart.attr('data-transportunitid', detailsCombined.params.transportUnitId);
                    $addToCart.attr('data-placefromid', detailsCombined.params.placeFromId);

                } else {
                    $unit.parent('div').prop('style', 'order: 100000;');
                }

                let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

                $unit.find('.unit-error-message').toggleClass('d-none', isBookable || unitData.message == "notAvailable");
                $unit.find('.unit-error-message').text(error);

                $unit.find('.rate-container').toggleClass('d-none', ! isBookable);
                $unit.find('.add-to-cart').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-book-one-unit').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-request').toggleClass('d-none', isBookable);
                
                $unit.find('.price-from-label').toggleClass('d-none', isBookable);
                $unit.find('.total-label').toggleClass('d-none', ! isBookable);
                $unit.find('.unit-numberOfPersons').toggleClass('d-none', isBookable);

            });

            if(this.$cart.length) {
                const $btnBooking = $('.btn-booking');

                $btnBooking.on('click', e => {
                    e.preventDefault();
                    let cartData = [];

                    detailsCombined.params.dynamicPackage = detailsCombined.params.dynamicPackage ? detailsCombined.params.dynamicPackage : 0;

                    this.cart.cartItems.forEach(item => {
                        item = JSON.parse(item);
                        cartData.push({
                            'unitId': item.unitId,
                            'dateFrom': item.dateFrom,
                            'dateTo': item.dateTo,
                            'aDateFrom': item.aDateFrom,
                            'aDateTo': item.aDateTo,
                            'guests': item.guests,
                            'flightUnitId': item.transportUnitId,
                            'placeFromId': item.placeFromId,
                            'time': item.time,
                            'serviceCode': item.serviceCode,
                            'serviceId': item.serviceId,
                            'pricelistId': detailsCombined.params.pricelistId,
                            'dynamicPackage': detailsCombined.params.dynamicPackage
                        });
                    });
                    let url = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=' + detailsCombined.params.dynamicPackage;

                    if(this.cart.cartItems.length) {
                        location = url;
                    } else {
                        $('#detailsCartModal').modal('show');
                        setTimeout(() => {
                            $('#detailsCartModal').modal('hide');
                        }, 2500);
                    }
                });
            } else {

                detailsCombined.getParams();

                $('.btn-book-one-unit').on('click', e => {
                    const $target = $(e.currentTarget); 
                    let cartData = [
                        {
                            'unitId': $target.attr('data-unitId'),
                            'dateFrom': detailsCombined.params.dateFrom,
                            'dateTo': detailsCombined.params.dateTo,
                            'guests': detailsCombined.params.guests,
                            'serviceCode': detailsCombined.params.serviceCode,
                            //'dynamicPackage': 0,
                        }
                    ];

                    location = $target.attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true'; // &dynamicPackage=0
                });
            }
        }
    },
    setActiveDeparture() {
        if (this.params.dateFrom) {

            let departureDateFrom = this.params.aDateFrom ? this.params.aDateFrom : this.params.dateFrom;
            let departureDateTo = this.params.aDateTo ? this.params.aDateTo : this.params.dateTo;

            const $departure = $('.departure[data-dateFrom="' + departureDateFrom + '"]');
            $departure.addClass('active');

            const dateFrom = new Date(this.params.dateFrom);
            const dateTo = new Date(this.params.dateTo);
            const diffInMs = dateTo.getTime() - dateFrom.getTime();
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

            const $departureSelection = $('.departure-selection');
            $departureSelection.find('.departure-dateFrom').text(functions.formatDate(departureDateFrom) + ' - ' + functions.formatDate(departureDateTo));
            $departureSelection.find('.departure-duration').text(diffInDays + ' noćenja');

            $('.accordion-summary .departure-dateFrom').text(functions.formatDate(departureDateFrom) + ' - ' + functions.formatDate(departureDateTo));
        }

        if (this.params.guests) {
            let guests = this.params.guests.split(',');
            $('.details-cart').find('.departure-guests').html(`
                ${ guests[0] } odrasli${ +guests[1] ? ', ' + guests[1] + ( +guests[1] == 1 ? ' dete' : ' dece') : ''}
            `);
        } else {
            $('.details-cart').find('.departure-guests').html(`
                <a href="" data-scroll-to="#booking,120">Odaberite broj gosta</a>
            `);
        }
    },
    showTransportSelect() {
        const $activeDeparture = $('.departure.active');
        const transportUnitId = $activeDeparture.data('flightunitid');
        $('.booking-combined-transport').toggleClass('d-none', ! transportUnitId);
    },
    prepareAvailabilityForm() {

        $('.tickets').append('<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>');
        $.post('/services/dynamic_package_availability_form_data/', {
            objectId: this.params.referenceId,
            dynamicPackage: 2, //this.params.dynamicPackage,
            language: functions.getLang(),
            flightAvailabilityStatus: true,
            placeFromId: this.params.placeFromId,
        }).always(response => {
            response = response ? JSON.parse(response) : null;

            if (response.status) {
                const prepared = this.getPackageDepartures(response.data.items, response.data.flights);
                this.departurePoints = response.data.departurePoints;
                const serviceCodes = response.data.serviceCodes;
                //const $nights = $("[name='nights']");

                this.enable = prepared.enable;
                this.flights = prepared.flights;
                this.prices = response.data.items; // prepared.prices;
                
                response.data.flights[0] && $('.transport-info').html(response.data.flights[0].summary);

                const $service = $("[name='serviceCode']");
                const $serviceWrapper = $service.parents('.service-code-wrapper');
                if (serviceCodes.length) {
                    $serviceWrapper.removeClass('d-none')
                    serviceCodes.forEach((serviceCode, key) => {
                        this.allowedServices.forEach((allowedService) => {
                            if (allowedService.key === serviceCode) {
                                serviceCodes[key] = {id: allowedService.key};
                                serviceCodes[key].text = allowedService.text;

                            }
                        });
                    });

                    $service.select2({
                        data: serviceCodes,
                        minimumResultsForSearch: -1
                    });
                } else {
                    $serviceWrapper.addClass('d-none');
                }

                let nights = this.enable.map(i => i['nights']);
                nights = nights.filter((value, index, array) => array.indexOf(value) === index).sort((a, b) => {
                    return a - b
                });

                if (nights.length) {
                    $('.package-duration-wrapper').removeClass('d-none');
                    $('.package-duration').text(nights.join(', ') + ' noćenja');

                    let _nights = [];
                    nights.forEach((night, key) => {
                        _nights.push({id: night, text: night})

                        if (!this.params.nights) {
                            this.params.nights = night;
                        }
                    });

                    //$nights.select2({
                    //    data: _nights,
                    //    minimumResultsForSearch: -1
                    //});

                    //setTimeout(() => $nights.val(this.params.nights).trigger('change'));

                } else {
                    $('.package-duration-wrapper').addClass('d-none');
                }

                this.enable.forEach(departure => {
                    const $departure = $('.departure[data-dateFrom="' + departure.aDateFrom + '"][data-dateTo="' + departure.aDateTo + '"]');
                    if ($departure.length) {
                        $departure.attr('data-departureDateFrom', departure.dateFrom);
                        $departure.attr('data-departureDateTo', departure.dateTo);
                        //$departure.attr('data-departureDateFrom', departure.dateFrom);
                        //$departure.attr('data-departureDateTo', departure.dateTo);
                        $departure.attr('data-flightUnitId', departure.flightUnitId);

                        //let unitId = $departure.data('unitid');

                        let rates = Object.values(this.prices).filter(rate => {
                            return rate.dateFrom == departure.dateFrom 
                                && rate.dateTo == departure.dateTo;
                                //&& unitId == rate.unitId.id;
                        });
                        rates.sort(function (a, b) {
                            return a.numberOfPersons - b.numberOfPersons;
                        });
                        let rate = rates[0];

                        $departure.append(`
                            <div class="departure-bus" data-departureBusPrice="${rate?.flight?.price}">
                                <i class="fa-solid fa-bus-side"></i>
                                <div class="departure-bus-price">+ € ${functions.formatMoney(rate?.flight?.price, 0, ',', '.')}</div>
                            </div>
                        `); // <br>po osobi
                    }
                });

                const $bookingCalendarSlider = $('#booking-calendar-slider');
                $bookingCalendarSlider.attr('data-departures', JSON.stringify(this.enable));
                //$bookingCalendarSlider.attr('data-flights', JSON.stringify(this.flights));
                this.$form.attr('data-flights', JSON.stringify(this.flights));
                $bookingCalendarSlider.attr('data-prices', JSON.stringify(this.prices));

                this.setDefaultDeparture();
                this.setActiveDeparture();

                //functions.setFormData(this.form, this.params);

                // showFlightTickets must MANDATORY be after setFormData
                this.params.dateFrom && this.showTransportTicket();
                //this.params.dynamicPackage == 2 && this.setDeparturePoints();
                this.setDeparturePoints();
                this.setUnitPrices();

                this.showTransportSelect()

                this.params.dateFrom && this.params.guests && this.getCalculation();

                this.$form.on('change', e => {
                    e.preventDefault();
                    const $target = $(e.currentTarget);
                    const data = functions.getFormData($target);

                    //this.params.dateFrom = data.dateFrom;
                    //this.params.dateTo = data.dateTo;
                    //this.params.aDateFrom = data.aDateFrom;
                    //this.params.aDateTo = data.aDateTo;

                    //this.params.time = data.time;
                    //this.params.duration = data.duration;
                    //this.params.transportUnitId = data.transportUnitId;

                    this.params.guests = data.guests;
                    this.params.placeFromId = data.placeFromId ? +data.placeFromId : null;
                    this.params.dynamicPackage = this.params.placeFromId ? 2 : 0;

                    //this.params.aDateFrom = this.params.dynamicPackage ? this.params.dateFrom : null;
                    //this.params.aDateTo = this.params.dynamicPackage ? this.params.dateTo : null;

                    //const $departure = $('.departure[data-dateFrom="' + this.params.aDateFrom + '"][data-dateTo="' + this.params.aDateTo + '"]');
                    const $departure = $('.departure.active');

                    if (this.params.dynamicPackage) {
                        this.params.dateFrom = $departure.data('departuredatefrom');
                        this.params.dateTo = $departure.data('departuredateto');
                        this.params.aDateFrom = $departure.data('datefrom');
                        this.params.aDateTo = $departure.data('dateto');
                        this.params.transportUnitId = this.params.dynamicPackage ? $departure.data('flightunitid') : null;

                        $('.departure-sopstveni').addClass('d-none');
                        $('.departure-bus-ticket').removeClass('d-none');
                    } else {
                        this.params.dateFrom = this.params.aDateFrom = $departure.data('datefrom');
                        this.params.dateTo = this.params.aDateTo = $departure.data('dateto');
                        this.params.transportUnitId = null;
                        this.params.placeFromId = null;
                        this.params.aDateFrom = null;
                        this.params.aDateTo = null;

                        $('.departure-bus-ticket').addClass('d-none');
                        $('.departure-sopstveni').removeClass('d-none');
                    }

                    functions.setUrlData(
                        {
                            'dateFrom': this.params.dateFrom,
                            'dateTo': this.params.dateTo,
                            'aDateFrom': this.params.aDateFrom,
                            'aDateTo': this.params.aDateTo,
                            'guests': this.params.guests,
                            'time': this.params.time,
                            'duration': this.params.duration,
                            'transportUnitId': this.params.transportUnitId,
                            'placeFromId': this.params.placeFromId,
                        },
                        true,
                        true);
                });

                $(document).on('click', '.ticket', e => {
                    //this.setTransportTicket($(e.currentTarget), true);
                });

                let travelProgramIds = [];
                response.data.flights.forEach((flight) => {
                    if (flight.travelProgramId ) {
                        travelProgramIds.push(flight.travelProgramId);
                    }
                });

                //this.getTravelProgram(travelProgramIds);

            }
        });
    },
    getPackageDepartures(rates, flightTitles) {
        let departures = {};

        Object.keys(rates).forEach(index => {
            let rate = rates[index];
            let flight = rate.flight;
            // let unique = rate.dateFrom + ',' + rate.dateTo + ',' + flight.timeDepartureFrom + ',' + flight.timeReturnFrom;
            //let unique = rate.aDateFrom + ',' + rate.aDateTo + ',' + rate.dateFrom + ',' + rate.dateTo;
            let unique = rate.dateFrom + ',' + rate.dateTo;
            
            let aDateFrom = rate.aDateFrom;
            let aDateTo = rate.aDateTo;

            let flightUnitId = flight.unitId;

            if ( flight.timeDepartureFrom ) {
                flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
            }

            let flightUnique = flightUnitId + (flight.time ? '_' + flight.time : '');

            if ( ! departures[unique]) {
                let flights = {};
                flights[flightUnique] = flight;

                let rates = {};
                rates[rate.id] = rate;

                departures[unique] = {
                    'dateFrom'      : rate.dateFrom,
                    'dateTo'        : rate.dateTo,
                    'aDateFrom'     : aDateFrom,
                    'aDateTo'       : aDateTo,
                    'time'          : flight.time || '',
                    'duration'      : rate.accommodationDuration,
                    'nights'        : rate.accommodationDuration,
                    'flightUnitId'  : flightUnitId,
                    'flights'       : flights,
                    'rates'         : rates,
                    'price'         : rate.price,
                    'numberOfPersons': rate.numberOfPersons,
                    'available'      : rate.available
                };
            } else {
                let departure = departures[unique];
                departure.flights[flightUnique] = flight;
                departure.rates[rate.id] = rate;

                // ako je price manji od prethodnog, spremi njega
                let numberOfPersons = +rate.numberOfPersons;
                let departurePrice = +departure.price;
                let ratePrice = +rate.price;

                if (numberOfPersons) {
                    departurePrice /= +departure.numberOfPersons;
                    ratePrice /= numberOfPersons;
                }

                if (ratePrice < departurePrice) {
                    departures[unique].price = rate.price;
                    departures[unique].numberOfPersons = rate.numberOfPersons;
                }

                if (rate.available) {
                    departures[unique].available = rate.available;
                }
            }
        });

        this.departures = departures;

        let enable = [];
        let prices = {};
        let flights = [];

        Object.keys(departures).forEach(index => {
            let rate = departures[index];

            enable.push({
                dateFrom: rate['dateFrom'],
                dateTo: rate['dateTo'],
                aDateFrom: rate['aDateFrom'],
                aDateTo: rate['aDateTo'],
                duration: rate['duration'],
                nights: rate['duration'],
                time: rate['time'],
                flightUnitId: rate['flightUnitId'],
                weekDayFrom: detailsCombined.getWeekDay(rate['dateFrom']),
                rates: rate['rates'],
                price: rate['price'],
                numberOfPersons: rate['numberOfPersons'],
                available: rate['available'],
            });

            let arrival = rate.dateFrom;
            let departure = rate.dateTo;

            let departureDay = detailsCombined.getWeekDay(arrival);
            let returnArrivalDay = detailsCombined.getWeekDay(departure);

            Object.keys(rate.flights).forEach(function(index) {

                let flight = rate.flights[index];

                if ( flight.timeDepartureFrom ) {
                    flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
                }

                let timeDepartureFrom = flight['timeDepartureFrom'];
                let timeDepartureTo = flight['timeDepartureTo'];
                let timeReturnFrom = flight['timeReturnFrom'];
                let timeReturnTo = flight['timeReturnTo'];
                let placeFromId = flight['placeFromId'];
                let placeFromName = flight['placeFrom'];
                let placeToName = flight['placeTo'];
                let departureDuration = flight['departureDuration'];
                let returnDuration = flight['returnDuration'];
                let arrivalDate = flight['arrivalDate'];
                let returnDate = flight['returnDate'];
                let availabilityStatus = flight['availabilityStatus'];

                let flightTitle;
                let flightSmallImg;
                let travelProgramId;
                flightTitles.forEach((ft) => {
                    if (ft.id == flight.objectId) {
                        flightTitle = ft.title ? ft.title : ft.supplierTitle;
                        flightSmallImg = ft.images.small ? ft.images.small : '';
                        travelProgramId = ft.travelProgramId;
                    }
                });

                let arrivalDay = detailsCombined.getWeekDay(arrivalDate);
                let returnDepartureDay = detailsCombined.getWeekDay(returnDate);
                
                flights.push({
                    duration              : rate.duration,
                    dateFrom              : rate.dateFrom,
                    dateTo                : rate.dateTo,    
                    aDateFrom             : rate.aDateFrom,
                    aDateTo               : rate.aDateTo,
                    flightId              : flight.objectId,
                    flightTitle           : flightTitle,
                    flightSmallImg        : flightSmallImg,
                    travelProgramId       : travelProgramId,
                    flightUnitId          : flight.unitId,
                    departureDay          : departureDay,
                    returnDepartureDay    : returnDepartureDay,
                    arrivalDay            : arrivalDay,
                    returnArrivalDay      : returnArrivalDay,
                    timeDepartureFrom     : timeDepartureFrom,
                    timeDepartureTo       : timeDepartureTo,
                    timeReturnFrom        : timeReturnFrom,
                    timeReturnTo          : timeReturnTo,
                    time                  : flight.time,
                    placeFromId           : placeFromId,
                    placeFromName         : placeFromName,
                    placeToName           : placeToName,
                    departureDuration     : departureDuration,
                    returnDuration        : returnDuration,
                    arrivalDate           : arrivalDate,
                    returnDate            : returnDate,
                    availabilityStatus    : availabilityStatus,
                });
            });

        });

        return {
            enable : enable,
            prices : prices,
            flights : flights
        };

    },
    getWeekDay(date) {

        const d = new Date(date);
        const days = [
            "nedelja",
            "ponedeljak",
            "utorak",
            "sreda",
            "četvrtak",
            "petak",
            "subota"
        ];

        let day = d.getDay()

        return days[day];
    },
    showTransportTicket() {
        const dataTransport = JSON.parse($('[data-flights]').attr('data-flights'));
        
        let dateFrom = this.params.dateFrom;
        let dateTo = this.params.dateTo;

        let duration = this.params.duration;
        let time = this.params.time != ' ' && (this.params.time && ! this.params.time.startsWith('null')) ? this.params.time : null;

        if (duration) {
            if (! $('.duration-item[data-datefrom="' + dateFrom + '"][data-dateto="' + dateTo + '"][data-duration="' + duration + '"]').length) {
                duration = this.params.duration = null;
            }
        }

        if (! duration && $('.duration-item.active').length) {
            duration && $('.duration-item.active').attr('data-duration');
        }

        let tickets = dataTransport.filter(ticket => {
            return ticket.dateFrom == dateFrom 
                && ticket.dateTo == dateTo 
                && (duration ? ticket.duration == duration : true)
                && (time ? ticket.time == time : true);
        });

        tickets.sort((a, b) => {
            return a.duration - b.duration;
        });

        this.renderTransportTickets(tickets);
    },
    renderTransportTickets(tickets) {
        if (tickets.length) {
            let ticket = tickets[0];
            let placeFromName = ticket.placeFromName;
    
            if (this.departurePoints && this.params.placeFromId) {
                this.departurePoints.forEach(departurePoint => {
                    if (departurePoint.placeId == this.params.placeFromId) {
                        placeFromName = departurePoint.placeName;
                    }
                });
            }
    
            $('.departure-departureFrom').html(`
                <div><span class="fw-bold">${placeFromName}</span> <small>${functions.formatDate(ticket.dateFrom)} - ${ticket.departureDay}</small></div> 
                <div><span class="fw-bold">${ticket.placeToName}</span> <small>${functions.formatDate(ticket.arrivalDate)} - ${ticket.arrivalDay}</small></div> 
            `);
            $('.departure-departureTo').html(`
                <div><span class="fw-bold">${ticket.placeToName}</span> <small>${functions.formatDate(ticket.returnDate)} - ${ticket.returnDepartureDay}</small></div> 
                <div><span class="fw-bold">${placeFromName}</span> <small>${functions.formatDate(ticket.dateTo)} - ${ticket.returnArrivalDay}</small></div> 
            `);
    
            $('.accordion-summary .departure-departureFrom').html(`
                ${placeFromName} - ${ticket.placeToName}
            `);
        }
    },
    setDeparturePoints () {

        setTimeout(() => {
            const $placeFromId = $('[name="placeFromId"]');
            $placeFromId.empty();
    
            // ali first zapamtiti i vratiti ga na prvo misto
            if (this.departurePoints) {
                const defaultDeparture = this.departurePoints[0];
    
                this.departurePoints.sort((a, b) => {
                    return a.placeName.localeCompare(b.placeName);
                });
    
                const itemIndex = this.departurePoints.findIndex(item => item == defaultDeparture);
                if (itemIndex) {
                    const [ item ] = this.departurePoints.splice(itemIndex, 1); // delete itemIndex
                    this.departurePoints.unshift(item); // add at first index
                }
    
                // departure active
                const $departure = $('.departure.active');
    
                const newOption = new Option('Sopstveni prevoz', 0, false, ! this.params.dynamicPackage);
                $placeFromId.append(newOption);
        
                this.departurePoints.forEach(departurePoints => {
    
                    let departurePlacePrice = +departurePoints.items[0].price;
                    let departurePrice = +$departure.find('.departure-bus').attr('data-departurebusprice');

                    departurePrice = departurePrice + departurePlacePrice;
    
                    const newOption = new Option(
                        `<div class="departure-point-option">
                            <div>${departurePoints.placeName}</div>
                            <div class="small"><span class="departure-point-option-price fw-bold me-1">€ ${functions.formatMoney(departurePrice, 0, ',', '.')}</span> po osobi</div>
                        </div>`, 
                        departurePoints.placeId, 
                        false, 
                        this.params.placeFromId == departurePoints.placeId);
    
                    $placeFromId.append(newOption);
                });
            }
        })

    },
    setUnitPrices() {
        if (! this.params.guests) {
            let dataPrices = $('[data-prices]').length ? JSON.parse($('[data-prices]').attr('data-prices')) : [];
            dataPrices = Object.values(dataPrices);
    
            $('#booking .unit.card').each((index, unit) => {
                const $unit = $(unit);
                const unitId = $unit.attr('data-unitId');
                const unitBeds = $unit.attr('data-beds');
    
                let unitRate = dataPrices.find(rate => {
                    if(
                        this.params.dateFrom == rate.dateFrom 
                        && this.params.dateTo == rate.dateTo 
                        && unitId == rate.unitId.id 
                        && (! rate.numberOfPersons || rate.numberOfPersons == unitBeds)
                    ) {
                        return rate;
                    }
                });
                
                let unitPrice = unitRate ? unitRate.price : null;
                if (unitRate && unitRate.numberOfPersons) {
                    unitPrice /= unitRate.numberOfPersons;
                }
    
                unitPrice && $unit.find('.price').text(functions.formatMoney(unitPrice, 0, '.', ','));
            });
        }
    },
};